"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLessThan = void 0;
exports.isLessThan = (a, b) => a < b;
//# sourceMappingURL=is-less-than.js.map